import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "request-submission-shift-container ml-20 mr-20" }
const _hoisted_2 = { class: "mb-7 mt-10 font-size-18" }
const _hoisted_3 = { class: "flex mb-4 items-center" }
const _hoisted_4 = { class: "w-48 text-right mr-8" }
const _hoisted_5 = { class: "w-104" }
const _hoisted_6 = { class: "flex mb-4 items-center" }
const _hoisted_7 = { class: "w-48 text-right mr-8" }
const _hoisted_8 = { class: "w-104 flex items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, "～", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "w-48 text-right mr-8" }
const _hoisted_12 = { class: "w-104" }
const _hoisted_13 = { class: "font-bold mb-2" }
const _hoisted_14 = { class: "flex mb-10" }
const _hoisted_15 = { class: "mr-12 w-full" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "flex justify-center span-action--active" }
const _hoisted_19 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19 6V18.5C19 19.8807 17.8807 21 16.5 21H7.5C6.11929 21 5 19.8807 5 18.5V6H4.5C4.22386 6 4 5.77614 4 5.5C4 5.22386 4.22386 5 4.5 5H9V4.5C9 3.67157 9.67157 3 10.5 3H13.5C14.3284 3 15 3.67157 15 4.5V5H19.5C19.7761 5 20 5.22386 20 5.5C20 5.77614 19.7761 6 19.5 6H19ZM6 6V18.5C6 19.3284 6.67157 20 7.5 20H16.5C17.3284 20 18 19.3284 18 18.5V6H6ZM14 4.5V5H10V4.5C10 4.22386 10.2239 4 10.5 4H13.5C13.7761 4 14 4.22386 14 4.5ZM14 9.5C14 9.22386 14.2239 9 14.5 9C14.7761 9 15 9.22386 15 9.5V16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5V9.5ZM9.5 9C9.22386 9 9 9.22386 9 9.5V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V9.5C10 9.22386 9.77614 9 9.5 9Z",
  fill: "#666666"
}, null, -1)
const _hoisted_20 = { class: "flex hover:text-blue-500" }
const _hoisted_21 = { class: "border h-66 w-94 text-center" }
const _hoisted_22 = { class: "mb-7 font-bold font-size-24 mt-8" }
const _hoisted_23 = { class: "mb-8" }
const _hoisted_24 = { class: "text-5xl mr-4" }
const _hoisted_25 = { class: "text-3xl" }
const _hoisted_26 = { class: "font-bold mb-2" }
const _hoisted_27 = { class: "flex justify-center span-action--active" }
const _hoisted_28 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19 6V18.5C19 19.8807 17.8807 21 16.5 21H7.5C6.11929 21 5 19.8807 5 18.5V6H4.5C4.22386 6 4 5.77614 4 5.5C4 5.22386 4.22386 5 4.5 5H9V4.5C9 3.67157 9.67157 3 10.5 3H13.5C14.3284 3 15 3.67157 15 4.5V5H19.5C19.7761 5 20 5.22386 20 5.5C20 5.77614 19.7761 6 19.5 6H19ZM6 6V18.5C6 19.3284 6.67157 20 7.5 20H16.5C17.3284 20 18 19.3284 18 18.5V6H6ZM14 4.5V5H10V4.5C10 4.22386 10.2239 4 10.5 4H13.5C13.7761 4 14 4.22386 14 4.5ZM14 9.5C14 9.22386 14.2239 9 14.5 9C14.7761 9 15 9.22386 15 9.5V16.5C15 16.7761 14.7761 17 14.5 17C14.2239 17 14 16.7761 14 16.5V9.5ZM9.5 9C9.22386 9 9 9.22386 9 9.5V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V9.5C10 9.22386 9.77614 9 9.5 9Z",
  fill: "#666666"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")
  const _component_Button = _resolveComponent("Button")
  const _component_RegisterTargetPersonPopup = _resolveComponent("RegisterTargetPersonPopup")
  const _component_ShiftSubmissionRequestPopup = _resolveComponent("ShiftSubmissionRequestPopup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('departmentForShiftCreation')), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Input)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('applicationSubmit')), 1),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", null, [
              _createVNode(_component_DatePicker, {
                width: "184",
                modelValue: _ctx.params.submissionDeadline,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.params.submissionDeadline = $event)),
                format: "YYYY/MM/DD"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_9,
            _createVNode("div", null, [
              _createVNode(_component_DatePicker, {
                width: "184",
                modelValue: _ctx.params.submissionDeadline,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.params.submissionDeadline = $event)),
                format: "YYYY/MM/DD"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('submissionDeadline')), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_DatePicker, {
              width: "184",
              modelValue: _ctx.params.submissionDeadline,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.params.submissionDeadline = $event)),
              format: "YYYY/MM/DD"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('membersToSubmitted')), 1),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_Table, {
              class: "h-130 text-center",
              "fixed-header": "",
              headers: _ctx.membersToSubmittedHeaders,
              data: _ctx.membersToSubmittedData
            }, {
              name: _withCtx(({ item }) => [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_Avatar, {
                    width: "40px",
                    height: "40px",
                    src: item.avatar,
                    class: "mr-2"
                  }, null, 8, ["src"]),
                  _createVNode("div", null, _toDisplayString(item.name), 1)
                ])
              ]),
              removeAction: _withCtx(() => [
                _createVNode("div", _hoisted_18, [
                  (_openBlock(), _createBlock("svg", {
                    class: "cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openMembersToSubmittedDeleteConfirm && _ctx.openMembersToSubmittedDeleteConfirm(...args))),
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _hoisted_19
                  ]))
                ])
              ]),
              _: 1
            }, 8, ["headers", "data"])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("span", {
              class: "flex cursor-pointer text-light-blue hover:opacity-75",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addTargetPerson && _ctx.addTargetPerson(...args)))
            }, [
              _createVNode("img", {
                src: _ctx.iconPlus,
                alt: "",
                srcset: ""
              }, null, 8, ["src"]),
              _createTextVNode(_toDisplayString(_ctx.t('addTargetPerson')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('numberOfPeopleToBeSubmitted')), 1),
          _createVNode("div", _hoisted_23, [
            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.numberOfPeopleToBeSubmitted), 1),
            _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t('person')), 1)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_Button, { class: "btn-gradation-light-blue h-10" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('requestSubmissionOfDesiredShiftBtn')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('requestHistory')), 1),
        _createVNode(_component_Table, {
          headers: _ctx.requestHistoryHeaders,
          data: _ctx.requestHistoryData,
          class: "text-center"
        }, {
          number_of_target_people: _withCtx(({ item }) => [
            _createVNode("a", {
              class: "cursor-pointer text-light-blue underline hover:opacity-75",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openShiftSubmissionRequestPopup && _ctx.openShiftSubmissionRequestPopup(...args)))
            }, _toDisplayString(item.number_of_target_people), 1)
          ]),
          cancel: _withCtx(() => [
            _createVNode("div", _hoisted_27, [
              (_openBlock(), _createBlock("svg", {
                class: "cursor-pointer",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openShiftSubmissionRequestDeleteConfirm && _ctx.openShiftSubmissionRequestDeleteConfirm(...args))),
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _hoisted_28
              ]))
            ])
          ]),
          _: 1
        }, 8, ["headers", "data"])
      ])
    ]),
    _createVNode(_component_RegisterTargetPersonPopup, {
      modelValue: _ctx.isShowAddTargetPersonPopup,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowAddTargetPersonPopup = $event)),
      onOnClose: _ctx.closeAddTargetPersonPopup
    }, null, 8, ["modelValue", "onOnClose"]),
    _createVNode(_component_ShiftSubmissionRequestPopup, {
      modelValue: _ctx.isShowShiftSubmissionRequestPopup,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowShiftSubmissionRequestPopup = $event)),
      onOnClose: _ctx.closeShiftSubmissionRequestPopup
    }, null, 8, ["modelValue", "onOnClose"])
  ], 64))
}